import faviconUrl from "../assets/favicon.png?url";
import logo380Url from "../assets/logo-380.webp?url";
import logo512Url from "../assets/logo-512.webp?url";
import logoHeroUrl from "../assets/logo-hero.webp?url";
import logoMarkUrl from "../assets/logo-mark.webp?url";

export const SITE_URL = "https://jackslockservice.com";
export const SITE_NAME = "Jack's Lock Service";

// Fingerprinted /assets/* URLs. The live host caches that path for a year.
// Unhashed files in public/ are served with no Cache-Control.
export const LOGO_HERO = logoHeroUrl;
export const LOGO_512 = logo512Url;
/** Hero logo sized for the mobile layout (about 380px wide). */
export const LOGO_380 = logo380Url;
export const LOGO_MARK = logoMarkUrl;
export const FAVICON = faviconUrl;

/** Old public paths, kept so existing shares and bookmarks still resolve. */
export const LEGACY_ASSET_REDIRECTS: Record<string, string> = {
  "/logo-hero.webp": LOGO_HERO,
  "/logo-512.webp": LOGO_512,
  "/logo-mark.webp": LOGO_MARK,
  "/favicon.png": FAVICON,
};

export const MAPS_EMBED =
  "https://www.google.com/maps?q=95-1003+Lalai+Street,+Mililani,+HI+96789&output=embed";
export const MAPS_LINK =
  "https://www.google.com/maps/search/?api=1&query=95-1003+Lalai+Street%2C+Mililani%2C+HI+96789";
